import { useEffect, useState } from 'react';
import { collection, onSnapshot, orderBy, query, where, Unsubscribe } from 'firebase/firestore';
import { firestore } from '@config/firebase';
import { PropertyInquiry } from '../types/inquiry.types';

/**
 * Inquiries the given tenant is part of (their matched-pair property inquiries),
 * used to surface landlord conversations in the tenant Chat list.
 */
export const useTenantInquiries = (tenantId?: string) => {
  const [inquiries, setInquiries] = useState<PropertyInquiry[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!tenantId) {
      setInquiries([]);
      setLoading(false);
      return;
    }

    setLoading(true);
    const inquiriesQuery = query(
      collection(firestore, 'inquiries'),
      where('tenantIds', 'array-contains', tenantId),
      orderBy('createdAt', 'desc')
    );

    const unsubscribe: Unsubscribe = onSnapshot(
      inquiriesQuery,
      (snapshot) => {
        setInquiries(
          snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() })) as PropertyInquiry[]
        );
        setLoading(false);
      },
      (error) => {
        console.error('Error fetching tenant inquiries:', error);
        setLoading(false);
      }
    );

    return () => unsubscribe();
  }, [tenantId]);

  return { inquiries, loading };
};
